export class ApiError extends Error {
  constructor(message: string, public status: number, public body?: Record<string, unknown>) { super(message) }
}

function csrfCookie() {
  return document.cookie.split('; ').find((item) => item.startsWith('zaocan_csrf='))?.split('=').slice(1).join('=') ?? ''
}

export async function api<T>(url: string, options: RequestInit & { operationId?: string } = {}): Promise<T> {
  const headers = new Headers(options.headers)
  if (options.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const method = (options.method ?? 'GET').toUpperCase()
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) headers.set('X-CSRF-Token', csrfCookie())
  if (options.operationId) headers.set('X-Operation-Id', options.operationId)
  const response = await fetch(url, { ...options, headers, credentials: 'same-origin', cache: 'no-store' })
  const body = response.headers.get('content-type')?.includes('json') ? await response.json() : null
  if (!response.ok) throw new ApiError(body?.error ?? '网络请求失败', response.status, body)
  return body as T
}

export const yuan = (fen: string | number | bigint | null | undefined) => fen == null ? '' : (Number(fen) / 100).toFixed(2)
export const money = (fen: string | number | bigint) => `¥${(Number(fen) / 100).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
